
<!-- app.component.html -->
<div class="card">
  <div class="card-header">
    <h4 class="card-title">Visão Geral do Cronograma</h4>
  </div>
  <div class="card-body">
    <div class="form-group">
      <label for="cronogramaSelect">Selecione o Cronograma</label>
      <select class="form-control" id="cronogramaSelect" [(ngModel)]="cronogramaSelecionado" (change)="onCronogramaChange()">
        <option [ngValue]="null">Selecione um cronograma</option>
        <option *ngFor="let cronograma of cronogramas" [value]="cronograma.id">
          {{ cronograma.nome }} - {{ cronograma.dataCriacao | date:'dd/MM/yyyy' }}
        </option>
      </select>
    </div>

    <div class="table-responsive">
      <table border="1" cellspacing="0" cellpadding="8">
        <thead>
          <tr>
            <th></th>  
            <th>Nome da Atividade</th>
            <th>EDT</th>
            <th>Indicador</th>
            <th>Inicio</th>
            <th>Fim</th>
            <th>% Trabalho Concluido</th>
            <th>Ações</th>        
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let node of dataSource">
            <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: node, level: 0 }"></ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
  
<ng-template #renderNode let-node let-level="level">
  <tr>
    <td>
      <span class="node-cell" [style.padding-left.px]="level * 20">
        <button
          *ngIf="node.children"
          (click)="toggleExpand(node)"
          [ngClass]="{ 'expand-button': !node.expanded, 'collapse-button': node.expanded }"
        >
          {{ node.expanded ? '-' : '+' }}
        </button>
        <span class="node-name">{{ node.name }}</span>
      </span>
    </td>
    <td>{{ node.atividade }}</td>
    <td>{{ node.EDT }}</td>
    
    <td> <i *ngIf="node.status == 'Ativo'" class="fas fa-circle text-success f-15 "></i>
      <i *ngIf="node.status != 'Ativo'" class="fas fa-circle text-danger f-15 "></i>
    </td>
    <td>{{ node.inicio }}</td>
    <td>{{ node.fim }}</td>
    <td>{{ node.description }}</td>
    <td></td>
  </tr>

  <ng-container *ngIf="node.expanded">
    <ng-container *ngFor="let child of node.children">
      <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: child, level: level + 1 }"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>